var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"AttachmentLinkCard",on:{"click":_vm.openNewTag}},[(_vm.title)?_c('div',{staticClass:"AttachmentLinkCard__title"},[_vm._v(_vm._s(_vm.title))]):_vm._e(),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.link))])])}
var staticRenderFns = []

export { render, staticRenderFns }